// extracted by mini-css-extract-plugin
module.exports = {"name":"formatters_name__3iob6"};